"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var component_modal_1 = require("@doordash/component-modal");
var component_overlay_1 = __importDefault(require("@doordash/component-overlay"));
var App_1 = require("../App");
var enums_1 = require("../Common/utils/enums");
var useTracking_1 = __importDefault(require("../Common/utils/useTracking"));
var i18n_1 = __importDefault(require("../i18n"));
var ResumeOrderForCheckout_1 = __importDefault(require("./Providers/ResumeOrderForCheckout"));
/* tslint:disable:max-line-length */
var ThreeDSecureVerifyMutation_1 = __importDefault(require("./Providers/ThreeDSecureVerifyMutation"));
var styles_1 = require("./styles");
var ThreeDSecureContext_1 = __importDefault(require("./ThreeDSecureContext"));
var PaymentIntentStatusType = {
    REQUIRES_CONFIRMATION: 'requires_confirmation',
    CANCELED: 'canceled'
};
var ExceptionReasons = {
    HANDLE_CARD_ACTION__ERROR: 'HANDLE_CARD_ACTION__ERROR',
    CANCELED: 'CANCELED',
    UNKNOWN: 'UNKNOWN',
    EXCEPTION: 'EXCEPTION'
};
// TODO: translate these
var ERROR_MESSAGE = 'An internal error occurred, please try again!';
var ERROR_TITLE = 'Unexpected Error';
var ThreeDSecureAuthView = function (_a) {
    var resumeOrder = _a.resumeOrder;
    var _b = React.useContext(App_1.RiskContext), dispatch = _b.dispatch, state = _b.state;
    var _c = React.useContext(ThreeDSecureContext_1["default"]), orderCart = _c.orderCart, threeDSecureMetaData = _c.threeDSecureMetaData;
    var threeDSecureVerify = ThreeDSecureVerifyMutation_1["default"]().threeDSecureVerify;
    var resumeOrderForCheckout = ResumeOrderForCheckout_1["default"]().resumeOrderForCheckout;
    var _d = useTracking_1["default"](orderCart.id), trackFailure = _d.trackFailure, trackSuccess = _d.trackSuccess;
    // by default the backdrop is visible
    var _e = __read(React.useState(true), 2), isBackdropVisible = _e[0], setIsBackdropVisible = _e[1];
    var _f = __read(React.useState(''), 2), errorMessage = _f[0], setErrorMessage = _f[1];
    var stripe = React.useMemo(function () { return window.Stripe(threeDSecureMetaData.key, { locale: i18n_1["default"].language }); }, [threeDSecureMetaData.key]);
    /**
     * Calls verify endpoint and handles the exceptions
     * If the resumeOrder is enabled, also calls the resumeOrderForCheckout api
     * @param status
     */
    var threeDSecurityVerifyAndResumeHandler = function (status) { return __awaiter(void 0, void 0, void 0, function () {
        var onErrorHandler, threeDSecureErrors, _a, data, resumeOrderErrors;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    onErrorHandler = function (msg) {
                        setErrorMessage(ERROR_MESSAGE);
                        trackFailure({
                            reason: ExceptionReasons.UNKNOWN,
                            message: msg || 'threeDSecureVerify endpoint failure'
                        });
                        dispatch({ type: enums_1.RiskActions.Reset });
                        setIsBackdropVisible(false);
                        return false;
                    };
                    return [4 /*yield*/, threeDSecureVerify(status)];
                case 1:
                    threeDSecureErrors = (_b.sent()).errors;
                    if (threeDSecureErrors && threeDSecureErrors.length > 0) {
                        return [2 /*return*/, onErrorHandler()];
                    }
                    if (!(resumeOrder && status === 'SUCCEEDED')) return [3 /*break*/, 3];
                    return [4 /*yield*/, resumeOrderForCheckout()];
                case 2:
                    _a = _b.sent(), data = _a.data, resumeOrderErrors = _a.errors;
                    if (!data.resumeOrderForCheckout.resumed ||
                        (resumeOrderErrors && resumeOrderErrors.length > 0)) {
                        return [2 /*return*/, onErrorHandler('resumeOrder endpoint failure')];
                    }
                    _b.label = 3;
                case 3: return [2 /*return*/, true];
            }
        });
    }); };
    var handleCardAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, handleCardActionError, paymentIntent, isVerified;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, stripe.handleCardAction(threeDSecureMetaData.clientSecret)];
                case 1:
                    _a = _b.sent(), handleCardActionError = _a.error, paymentIntent = _a.paymentIntent;
                    if (!handleCardActionError) return [3 /*break*/, 3];
                    trackFailure({
                        reason: ExceptionReasons.HANDLE_CARD_ACTION__ERROR,
                        message: handleCardActionError.message
                    });
                    return [4 /*yield*/, threeDSecurityVerifyAndResumeHandler('FAILED')];
                case 2:
                    _b.sent();
                    setErrorMessage(ERROR_MESSAGE);
                    return [3 /*break*/, 9];
                case 3:
                    if (!(paymentIntent &&
                        paymentIntent.status === PaymentIntentStatusType.REQUIRES_CONFIRMATION)) return [3 /*break*/, 5];
                    return [4 /*yield*/, threeDSecurityVerifyAndResumeHandler('SUCCEEDED')];
                case 4:
                    isVerified = _b.sent();
                    if (isVerified === true && state.onSuccess) {
                        trackSuccess();
                        state.onSuccess(resumeOrder);
                    }
                    dispatch({ type: enums_1.RiskActions.Reset });
                    setIsBackdropVisible(false);
                    return [3 /*break*/, 9];
                case 5:
                    if (!(paymentIntent &&
                        paymentIntent.status === PaymentIntentStatusType.CANCELED)) return [3 /*break*/, 7];
                    trackFailure({ reason: ExceptionReasons.CANCELED });
                    return [4 /*yield*/, threeDSecurityVerifyAndResumeHandler('CANCELED')];
                case 6:
                    _b.sent();
                    return [3 /*break*/, 9];
                case 7:
                    trackFailure({
                        reason: ExceptionReasons.UNKNOWN,
                        message: "Unexpected payment intent status: " + (paymentIntent ? paymentIntent.status : 'NA')
                    });
                    setErrorMessage(ERROR_MESSAGE);
                    return [4 /*yield*/, threeDSecurityVerifyAndResumeHandler('UNKNOWN')];
                case 8:
                    _b.sent();
                    _b.label = 9;
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var memoizedHandleCardAction = React.useCallback(handleCardAction, [
        orderCart.id,
    ]);
    React.useEffect(function () {
        memoizedHandleCardAction();
    }, [orderCart.id]);
    return (React.createElement(React.Fragment, null,
        errorMessage && (React.createElement(component_modal_1.Alert, { title: ERROR_TITLE, subtitle: errorMessage, dismissText: "Continue" })),
        !errorMessage && isBackdropVisible && (React.createElement(styles_1.AuthViewBackdrop, null,
            React.createElement(component_overlay_1["default"], { isVisible: true, type: component_overlay_1["default"].Types.Loading })))));
};
exports["default"] = ThreeDSecureAuthView;
